import { create } from 'zustand';

interface BalanceUIState {
  periodo: string;
  cantidadMeses: number;
  vista: 'resumido' | 'detallado';

  setPeriodo: (value: string) => void;
  setCantidadMeses: (value: number) => void;
  setVista: (value: 'resumido' | 'detallado') => void;

  reset: () => void;
}

const initialState = {
  periodo: '',
  cantidadMeses: 6,
  vista: 'resumido' as const,
};

export const useBalanceUIStore = create<BalanceUIState>((set) => ({
  ...initialState,

  setPeriodo: periodo => set({ periodo }),
  setCantidadMeses: cantidadMeses => set({ cantidadMeses }),
  setVista: vista => set({ vista }),

  reset: () => set(initialState),
}));
